export default __webpack_public_path__ + "static/Artboard-6-0a2a599f2174f7433fcab5842c9ce392.webp";